import React from "react"
import { Flex, Box } from "theme-ui"
import Select from "react-select"
import { faTimes } from '@fortawesome/free-solid-svg-icons'
import NewBoxButton from "../Radiate/NewBoxButton/NewBoxButton"
import TextField from "../Radiate/TextField/TextField"
import * as Styles from "./IceBreakerAndPersistentMenuFieldStyles"

const IceBreakerAndPersistentMenuField = ({
  action,
  onChange,
  onRemove,
  type,
  index
}) => {
  let buttonTitle
  let label
  if (type === "pm") {
    buttonTitle =  action.title
    label = "Title"
  } else if (type === "ib") {
    buttonTitle = action.question
    label = "Question"
  }

  const typeOptions = [{
    label: "Postback",
    value: "postback"
  }, {
    label: "URL",
    value: "web_url"
  }]
  return (
    <Box
      py={3}
      px={3}
      mb={3}
      sx={{
        background: "#f5f5f5",
        borderRadius: "6px"
      }}
    >
      <Flex sx={{ justifyContent: "space-between", alignItems: "center"}}>
        <Styles.IndexText>#{index + 1}</Styles.IndexText>
        <NewBoxButton
          icon={faTimes}
          inverted
          onClick={() => {
            onRemove(index)
          }}
        />
      </Flex>
      <Box pb={2}>
        <TextField
          label={label}
          value={buttonTitle}
          borderStyle
          onChange={(e) => {
            if (type === "pm") {
              onChange({
                ...action,
                title: e.target.value
              })
            } else {
              onChange({
                ...action,
                question: e.target.value
              })
            }
            
          }}
        />
      </Box>
      {type === "pm" && 
        <Box pb={2}>
          <Styles.Label>Button Type</Styles.Label>
          <Select
            options={typeOptions}
            value={typeOptions.find(o => o.value === action.type)}
            onChange={(value) => {
              onChange({
                ...action,
                type: value.value
              })
            }}
            styles={{
              container: styles => ({
                ...styles,
                "span": {
                  height: "0px"
                }
              }),
              control: styles => ({
                ...styles,
                height: "31px",
                minHeight: "31px"
              }),
              valueContainer: styles => ({
                ...styles,
                padding: "2px 4px"
              }),
              indicatorsSeparator: styles => ({
                ...styles,
                height: "12px"
              }),
              singleValue: styles => ({
                ...styles,
                top: "48%"
              }),
              indicatorsContainer: styles => ({
                ...styles,
                padding: "0px",
                height: "30px",
              })
            }}
          />
        </Box>
      }
      {action?.type === "web_url" ?
        <Box>
          <TextField
            label="URL"
            value={action.url}
            borderStyle
            onChange={(e) => {
              onChange({
                ...action,
                url: e.target.value
              })
            }}
          />
        </Box>
        :
        <Box>
          <TextField
            label="Payload"
            value={action.payload}
            borderStyle
            onChange={(e) => {
              onChange({
                ...action,
                payload: e.target.value
              })
            }}
          />
        </Box>
      }
    </Box>
  )
}

export default IceBreakerAndPersistentMenuField